import React, { useEffect, useState } from "react";
import {
  Card,
  Typography,
  DatePicker,
  Col,
  Layout,
  Row,
  List,
  Image,
  Carousel,
  Skeleton,
  Pagination,
  Drawer,
  Button,
  Space,
} from "antd";
import type { Dayjs } from "dayjs";
import MenuBar from "../../components/Menu/MenuBar";
import Footer from "../../components/Footer/Footer";
import SearchEventsForm from "../../components/Forms/SearchEventsForm";
import useEventsSearch from "../../../hooks/events-hook";
import { Events, PageSetting, Query } from "../..";
import { useNavigate, useParams } from "react-router-dom";
import { findById } from "../../../controllers/store/actions/events/update-event-actions";
import store from "../../../controllers/store";
import { useSelector } from "react-redux";
import { EventsAdapter } from "../../../adapter/events-adapter";

const { Content } = Layout;
const { RangePicker } = DatePicker;
const { Title, Text } = Typography;
const query: Query = { filter: {} };
const dispatch = store.dispatch;
export default function EventsListings() {
  const navigate = useNavigate();
  const { eventId } = useParams(); // A
  const { result, searchEvents } = useEventsSearch();
  const [isListView, setIsListView] = useState(true);
  const [loading, setLoading] = useState(false);
  const [pageEvents, setpageEvents] = useState<number>(0);
  const [searchText, setSearchText] = useState("");
  const [eventDetailed, setEventdetailed] = useState<Events | null>(null);
  const [organizerSearchText, setOrganizerSearchText] = useState("");
  const [eventType, setEventType] = useState<
    "Presencial" | "Virtual" | "Mixto" | null
  >(null);
  const [selectedDateRange, setSelectedDateRange] = useState<
    [Dayjs | null, Dayjs | null]
  >([null, null]);
  const [organizer, setOrganizer] = useState("");
  const updatedEventState = useSelector((state: any) => state.updatedEvent);

  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const detail = (params: any) => {
    if ((params.id ? params.id : params).toString() == eventId) {
      return showDrawer();
    }
    navigate(`/events-listing/${params.id ? params.id : params}`);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (eventId) {
      console.log("parametro dimanico ", eventId);
      dispatch(findById(eventId));
      showDrawer();
    }
  }, [eventId]);

  useEffect(() => {
    searchEvents(
      "events",
      {
        filter: `&filter[visibility_end_date][_gt]=${new Date().toISOString()}&filter[status][_eq]=Published`,
      },
      1,
      PageSetting.limit
    );
  }, [searchText]);

  const renderListItem = (event: Events, index: any) => (
    <List.Item onClick={() => detail(event)}>
      <List.Item.Meta
        avatar={
          event && (
            <Image
              src={event.banner}
              alt={event.name}
              width={400}
              height={200}
              style={{ objectFit: "cover", borderRadius: "8px" }}
              preview={false}
            />
          )
        }
        title={<Text strong>{event.name}</Text>}
        description={
          <>
            <Text type="secondary">
              {event.visibility_start_date} - {event.visibility_end_date}
            </Text>
            <br />
            {event.location && <Text>{event.location}</Text>}
            <br />
            <br />
            <Text strong>Organizador:</Text> {event.organizer_fullname}
            <br />
            <Text strong>Tipo de evento:</Text> {event.type}
            <br />
            {event.description && (
              <Text type="secondary">{event.description}</Text>
            )}
          </>
        }
      />
    </List.Item>
  );

  const renderGridCard = (event: Events) => (
    <Card
      onClick={() => detail(event.id)}
      hoverable
      cover={
        event.banner && (
          <Image
            src={event.banner}
            alt={event.name}
            height={200}
            style={{ objectFit: "cover" }}
            preview={false}
          />
        )
      }
    >
      <Card.Meta
        title={event.name}
        description={
          <div>
            <Text strong>Descripción:</Text> {event.description}
            <br />
            <Text type="secondary">
              {event.visibility_start_date} - {event.visibility_end_date}
            </Text>
            <br />
            {event.location && <Text>{event.location || "N/A"}</Text>}
            <br />
            <Text strong>Organizador:</Text> {event.organizer_fullname}
            <br />
            <Text strong>Tipo de evento:</Text> {event.type}
          </div>
        }
      />
    </Card>
  );

  return (
    <Layout className="events-listings-layout">
      <Drawer
        title="Detalle de evento"
        width={720}
        onClose={onClose}
        open={open}
        styles={{
          body: {
            paddingBottom: 80,
          },
        }}
      >
        {/* Aquí van los detalles del evento en el Drawer */}
        <Skeleton
          loading={updatedEventState.isLoading}
          active
          className="full-width"
        >
          <div key={1}>
            {updatedEventState.eventDetailed && (
              <>
                <Image
                  onClick={() => {
                    if (updatedEventState.event.url) {
                      window.open(
                        updatedEventState.eventDetailed.url,
                        "_blank"
                      );
                    }
                  }}
                  src={updatedEventState.eventDetailed.banner}
                  alt={updatedEventState.eventDetailed.name}
                  height={200}
                  style={{ objectFit: "cover", borderRadius: "8px" }}
                  preview={false}
                />
                <Title level={3}>{updatedEventState.eventDetailed.name}</Title>
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <Text strong>Descripción:</Text>{" "}
                    <Text>{updatedEventState.eventDetailed.description}</Text>
                  </Col>
                  <Col span={12}>
                    <Text strong>Fecha de inicio:</Text>{" "}
                    <Text>
                      {updatedEventState.eventDetailed.visibility_start_date}
                    </Text>
                  </Col>
                  <Col span={12}>
                    <Text strong>Fecha finalización:</Text>{" "}
                    <Text>
                      {updatedEventState.eventDetailed.visibility_end_date}
                    </Text>
                  </Col>
                  <Col span={24}>
                    <Text strong>Ubicación:</Text>{" "}
                    <Text>{updatedEventState.eventDetailed.location}</Text>
                  </Col>
                  <Col span={24}>
                    <Text strong>Organizador:</Text>{" "}
                    <Text>
                      {updatedEventState.eventDetailed.organizer_fullname}
                    </Text>
                  </Col>
                  <Col span={24}>
                    <Text strong>Tipo de evento:</Text>{" "}
                    <Text>{updatedEventState.eventDetailed.type}</Text>
                  </Col>
                  <br />
                  <br />
                  <Col span={24}>
                    <Button
                      type="primary"
                      size={"large"}
                      onClick={() => {
                        if (updatedEventState.event.url) {
                          window.open(
                            updatedEventState.eventDetailed.url,
                            "_blank"
                          );
                        }
                      }}
                    >
                      Participar
                    </Button>
                  </Col>
                </Row>
              </>
            )}
          </div>
        </Skeleton>
      </Drawer>
      <MenuBar />
      <Skeleton loading={result.loading} active className="full-width">
        {/* Carousel */}
        <Carousel autoplay>
          {result.values.map((event) => (
            <div>
              <Image
                onClick={() => {
                  if (event.url) {
                    window.open(event.url, "_blank");
                  }
                }}
                src={event.banner}
                alt={event.name}
                width="100%"
                height={450}
                style={{ objectFit: "cover" }}
                preview={false}
              />
            </div>
          ))}
        </Carousel>
      </Skeleton>
      <Content className="bg-gray-50">
        <div style={{ padding: "40px" }}>
          <div className="max-w-7xl mx-auto">
            <div className="mb-8">
              <Title
                level={2}
                style={{
                  color: "#ff6b00",
                  borderLeft: "4px solid #ff6b00",
                  paddingLeft: "16px",
                }}
              >
                Eventos
              </Title>
            </div>
            <br />
          </div>
          <SearchEventsForm
            onDateRangeSelect={(dates: [Dayjs | null, Dayjs | null]) => {
              setSelectedDateRange(dates);
              if (!dates) {
                delete query.filter.visibility_start_date;
              } else {
                query.filter.visibility_start_date = `&filter[visibility_start_date][_between]=${dates[0]?.format(
                  "YYYY-MM-DD"
                )},${dates[1]?.format("YYYY-MM-DD")}&`;
              }
            }}
            onOrganizerChangeValue={(value) => {
              setOrganizer(value);
              if (!value) {
                delete query.filter.organizer_fullname;
              } else {
                query.filter.organizer_fullname = `&filter[organizer_fullname][_icontains]=${value}&`;
              }
            }}
            onEventTypeValueChange={(value) => {
              setEventType(value);
              console.log("type", value);
              if (!value) {
                delete query.filter.type;
              } else {
                query.filter.type = `&filter[type][_eq]=${value}&`;
              }
            }}
            onSearch={function (value: string): void {
              if (!value) {
                delete query.filter.search;
              } else {
                query.filter.search = `&search=${value}&`;
              }
              searchEvents("events", query, 1, PageSetting.limit);
            }}
            onSearchPressEnter={function (value: any): void {
              if (!value) {
                delete query.filter.search;
              } else {
                query.filter.search = `&search=${value}&`;
              }

              searchEvents("events", query, 1, PageSetting.limit);
            }}
            onChangeViewLayout={function (value: boolean): void {
              setIsListView(value);
            }}
          />
          <Skeleton loading={result.loading} active className="full-width">
            {/* Events Display */}
            <br />
            <br />
            <br />
            <div className="max-w-5xl mx-auto p-4">
              {isListView ? (
                <List
                  itemLayout="vertical"
                  dataSource={result.values}
                  renderItem={renderListItem}
                />
              ) : (
                <Row gutter={[16, 16]}>
                  {result.values.map((event: Events) => (
                    <Col key={event.id} xs={24} sm={12} md={8}>
                      {renderGridCard(event)}
                    </Col>
                  ))}
                </Row>
              )}
            </div>
          </Skeleton>
        </div>
        <br />
        <Row gutter={[8, 8]} style={{ width: "100%", textAlign: "center" }}>
          <Col xs={24} sm={12} md={8} lg={24}>
            <Pagination
              showSizeChanger={false}
              pageSize={PageSetting.limit}
              current={pageEvents}
              defaultCurrent={PageSetting.page}
              total={result.pagination?.total}
              onChange={async (page, pageSize) => {
                searchEvents("events", query, page, PageSetting.limit);
                setpageEvents(page);
              }}
            />
          </Col>
        </Row>
        <br />
        <br />
      </Content>
      <Footer />
    </Layout>
  );
}
